const SubSearchFormLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "R_CUSTOMER",
                "tableName": "",
                "label": "Customer:",
                "type": "select",
                "options": [""],
                "apiUrl": "",
                "grid": null,
                "required": false,
                "visible": true

            } 
        ]
    },
    {
        "groupId": 2,
        "label": "",
        "fields": [
            {
                "name": "customerName",
                "tableName": "",
                "label": "Customer Name",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true
            } 
        ]
    },
    {
        "groupId": 3,
        "label": "",
        "fields": [
            {
                "name": "subLotCode",
                "tableName": "",
                "label": "Sub Lot Code",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true

            } 
        ]
    },
    {
        "groupId": 4,
        "label": "",
        "fields": [
            {
                "name": "subLotDescription1",
                "tableName": "",
                "label": "Description1",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true
            } 
        ]
    }
];
export default SubSearchFormLayout;